import React from "react";
import { DateTimePicker } from "@material-ui/pickers";
import { DatePickerProps } from "./types";

const DatePicker = ({
  value,
  onChange,
  disabled,
  label,
  views,
  format
}: DatePickerProps) => {
  return (
    <DateTimePicker
      value={value}
      onChange={onChange}
      disabled={disabled}
      ampm={false}
      label={label}
      views={views}
      format={format}
    />
  );
};

export default DatePicker;
